module.exports = __webpack_public_path__ + "assets/8a51fdbc971c9c160791315bd9c06c71.eot";